export default __webpack_public_path__ + "static/media/wafer-bg-left.f9fa102d.png";